module.exports = __webpack_public_path__ + "static/sofiapro-600-34867c36f587fdcc21b6ec12131c7a02.woff";